<template>
  <v-layout
    v-if="item"
    row
    wrap
  >
    <v-flex
      xs12
      wrap
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          sm12
          md6
          xl6
          class="detail-section"
        >
          <a
            class="detail-img"
            target="_blank"
            :href="getImage(item)"
          >
            <img
              :src="getImage(item)"
              :alt="item.name"
              width="100%"
            >
          </a>
          <slot name="buttons" />
        </v-flex>
        <v-flex
          sm12
          md6
          xl6
          class="detail-section"
        >
          <v-layout column>
            <div class="display-1 title-text">
              {{ item.name }}
            </div>
            <v-layout
              column
              class="content"
            >
              <slot name="content" />
            </v-layout>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      wrap
      v-if="!!this.$store.getters.getUser"
      class="detail-section"
      style="background-color: #fffdf2;"
    >
      <slot name="auth-content" />
    </v-flex>
    <v-flex
      v-show="isShowRelatedProducts"
      xs12
      wrap
    >
      <v-layout
        row
        wrap
        class="detail-section"
      >
        <v-flex
          xs12
          wrap
          class="related-products-title"
        >
          <!-- 연관 상품란 제목 -->
          <div class="related-products-title">
            {{ $t('variables.relatedProducts') }}
          </div>
        </v-flex>
        <v-flex
          v-if="item.recommend_prinkfong_products && item.recommend_prinkfong_products.length > 0"
          xs12
          wrap
        >
          <!-- 부제목 : 핑크퐁 직제품-->
          <div class="related-products-subtitle">
            {{ $t('variables.pinkfongproducts') }}
          </div>
          <list
            v-if="item.recommend_prinkfong_products"
            :items="item.recommend_prinkfong_products"
            model-name="pinkfongproducts"
            :flex-class="'pa-3'"
            :list-break-point="pinkfongBreakpoint"
            :is-related-card="true"
          />
        </v-flex>
        <v-flex
          v-if="item.recommend_licensed_products && item.recommend_licensed_products.length > 0"
          xs12
          wrap
        >
          <!-- 부제목 : 라이센스 상품 -->
          <p class="related-products-subtitle">
            {{ $t('variables.licensedproducts') }}
          </p>
          <list
            v-if="item.recommend_licensed_products"
            :items="item.recommend_licensed_products"
            model-name="licensedproducts"
            :flex-class="'pa-3'"
            :list-break-point="licenceBreakpoint"
            :is-related-card="true"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
  <v-layout
    v-else
    row
    wrap
  >
    <v-flex
      xs12
      wrap
    >
      <slot name='not-found' />
    </v-flex>
  </v-layout>
</template>

<script>
import List from 'components/List.vue'

export default {
  components: {
    'list': List
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  metaInfo () {
    return {
      meta: [
        { vmid: 'og:description', property: 'og:description', content: this.item.name },
        { vmid: 'og:image', property: 'og:image', content: this.getImage(this.item) }
      ]
    }
  },
  data () {
    return {
      imageUrl: ''
    }
  },
  computed: {
    pinkfongBreakpoint () {
      return {
        'xs': 6,
        'sm': 4,
        'md': 4,
        'lg': 3,
        'xl': 3
      }
    },
    licenceBreakpoint () {
      return {
        'xs': 6,
        'sm': 4,
        'md': 4,
        'lg': 3,
        'xl': 3
      }
    },
    isShowRelatedProducts () {
      const product = this.$route.path.split('/')[2]
      if (product === 'mediacontent') {
        return false
      }
      if ((this.item.recommend_licensed_products || []).length === 0 && (this.item.recommend_pinkfong_products || []).length === 0) {
        return false
      }
      return true
    }
  },
  created () {
    this.$eventBus.$on('detailToggle', this.detailToggle)
  },
  beforeDestroy () {
    this.$eventBus.$off('detailToggle')
  },
  methods: {
    detailToggle (code) {
      let item = this.item
      if (code !== item.code) {
        return
      }
      const routeName = this.$route.name.split('_')[0]
      item.product = routeName
      this.$store.commit('toggleItem', item)
    },
    getImage (item) {
      if (item.images) {
        return item.images[0].image.origin
      } else {
        return ''
      }
    }
  }
}
</script>

<style>
  .slide-enter-active {
    transition: all .5s ease;
  }
  .slide-enter {
    transform: translateX(100%);
  }
  .content {
    white-space: pre-line;
  }

  .display-1.title-text {
    font-size: 26px !important;
  }
  .detail-img:hover {
    cursor: zoom-in;
  }

  .detail-section {
    padding: 30px;
  }

  .detail-section .related-products-title {
    font-size: 26px;
  }

  .detail-section .related-products-subtitle {
    font-size: 20px;
    margin-top: 15px;
    margin-bottom: 0px;
  }

  @media (max-width: 599px) {
    .detail-section {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue